import React, { JSX } from 'react';

const Summary = (): JSX.Element => {
  return <></>;
};

export default Summary;
